import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  okay: () => __(translations.interactionForm.okay, 'Okay'),
  title: () => __(translations.interactionForm.alertTitle, 'Interaction'),
  type: () => __(translations.interactionForm.type, 'Type'),
  comment: () => __(translations.interactionForm.comment, 'Comment'),
};
